import { defineComponent as _defineComponent } from 'vue'
import { Portal } from '@linusborg/vue-simple-portal'
import { onMounted, ref } from 'vue'
import BaseTable from '../../../@web/ui/components/baseTable/BaseTable.vue'
import Button from '../../../components/ui/button/Button.vue'
import ContextMenu from '../../../components/ui/contextMenu/ContextMenu.vue'
import Input from '../../../components/ui/input/Input.vue'
import Pagination from '../../../components/ui/pagination/Pagination.vue'
import ProgressBar from '../../../components/ui/progressBar/ProgressBar.vue'
import SidePanel from '../../../components/ui/sidePanel/SidePanel.vue'
import { tiposDeOrdensDeServico } from '../../../constants/Mappings/TiposDeOrdensDeServico.js'
import LayoutCrud from '../../../layouts/LayoutCrud.vue'
import i18n from '../../../VueI18n.js'
import FormOrdemServico from './FormOrdemServico.vue'

import { useRegistryUtils } from '../../../composables/useRegistryUtils.js'
import { getAllOrdensDeServicos } from '../../../services/requests/OrdemDeServicoRequests.js'

import { useOrdemServico } from '../../../composables/useOrdemServico.js'
import { ContextMenuOption } from '../../../components/ui/contextMenu/dtos/ContextMenuOption.dto'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdemServico',
  setup(__props) {

const { ordemServico, criarNovaOrdemServico, resetOrdemServico } = useOrdemServico()

const ordensServicoTable = ref([])
const showSidePanel = ref(false)

function closeSidePanel() {
	showSidePanel.value = false
	resetOrdemServico()
}

onMounted(() => {
	getAllOrdensDeServicos().then((data) => {
		ordensServicoTable.value = data.data.result.map((os: any) => {
			return {
				...os,
				progresso: os.porcentagemParcelasColetadas,
				dataFinal: new Date(os.orsv_dt_prazo_final).toLocaleDateString(),
				dataInicial: new Date(os.orsv_dt_data_inicial).toLocaleDateString(),
			}
		})
	})
})

const colunas = ref([
	{
		name: 'Código',
		key: 'orsv_cd_codigo',
		enableSort: true,
	},
	{
		name: 'Estrato florestal',
		key: 'esfl_cd_codigo',
	},
	{
		name: 'Tipo de OS',
		key: 'tpsv_cd_codigo',
		enableSort: true,
	},
	{
		name: 'Descrição',
		key: 'orsv_ds_descricao',
	},
	{
		name: 'Data inicial',
		key: 'dataInicial',
	},
	{
		name: 'Data final',
		key: 'dataFinal',
	},
	{
		name: 'Progresso da OS',
		key: 'progresso',
		component: ProgressBar,
		enableSort: true,
	},
])

function handleResumo() {
	//temp
}

const deletePopup = ref(false) //temp

const {
	pageData,
	searchTerm,
	entriesToDelete,
	pageSize,
	page,
	onPageChange,
	downloadExemplo,
	sortBy,
} = useRegistryUtils(ordensServicoTable, colunas)

function kebabOptions(ordemDeServico: any): ContextMenuOption[] {
	var options = [
		{
			icon: 'ic:round-edit',
			event: 'editar',
			name: i18n.t('edit'),
		},
	]

	if (ordemDeServico.orsv_is_blocked) {
		options.push({ icon: 'ooui:un-block', event: 'unblockOS', name: i18n.t('unblockOS') })
	}

	if (ordemDeServico.orsv_dt_data_final == null)
		options.push({ icon: 'basil:lock-solid', event: 'fecharOS', name: i18n.t('closeOrder') })
	else options.push({ icon: 'basil:unlock-solid', event: 'abrirOS', name: i18n.t('openOrder') })

	if (
		ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO ||
		ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_CONTINUO ||
		ordemDeServico.tpsv_cd_codigo === tiposDeOrdensDeServico.INVENTARIO_PRE_CORTE
	) {
		options.push({
			icon: 'ph:polygon',
			event: 'visualizarDispersao',
			name: i18n.t('visualizeDispersion'),
		})
	}

	return options as ContextMenuOption[]
}
// Your script setup content goes here

return { __sfc: true,ordemServico, criarNovaOrdemServico, resetOrdemServico, ordensServicoTable, showSidePanel, closeSidePanel, colunas, handleResumo, deletePopup, pageData, searchTerm, entriesToDelete, pageSize, page, onPageChange, downloadExemplo, sortBy, kebabOptions, Portal, BaseTable, Button, ContextMenu, Input, Pagination, SidePanel, LayoutCrud, FormOrdemServico }
}

})